<template>
    <div v-if="!isMobile || (isMobile && !current_room.id)" :class="'chats-wrapper ' + (isMobile ? 'is-mobile' : '')">
        <div class="chats-header">
            <span v-if="!isMobile">Чаты</span>
            <div class="roomCreator" @click="createRoom"> Создать комнату</div>
        </div>
        <div class="rooms">
            <div
                v-for="(item, index) in roomList"
                :key="index"
                class="room"
                @click="$emit('change-current-room', item)"
                :class="[{ 'current-room': item.id == currentRoom.id },
                    { 'hasUnreadMessageBg': unreadMessageComputeStyle(item) }]"
            >

                <div class="room-img-wrapper">
                    <div class="room-img"
                    >
                        <div class="singroomImgItem"
                             v-if="item.users.length == 1"
                             :style="`background-image: url(${item.users[0].avatar})`"
                        ></div>
                        <div class="singroomImgItem"
                             v-if="item.users.length == 0 "
                        ></div>
                        <div
                            v-else
                            class="roomImgItem"
                            v-for="(us, usindex) in item.users"
                            :key="usindex"
                            :style="`background-image: url(${us.avatar})`"
                        ></div>
                    </div>
                </div>
                <div class="room-name">
                    <div class="room-first" v-if="item.users.length < 3">
                        <div style="float: left">
                            <div
                                v-for="(user, userIndex) in item.users"
                                :key="userIndex"
                            >
                                {{user.name}}
                                {{user.surname}}
                                {{user.patronimic}}<span v-if="item.users.length-1 !== userIndex">,</span>
                            </div>
                        </div>

                        <div style="float: right" class="unreadMessages" v-if="item.new_messages > 0">
                            {{item.new_messages}}
                        </div>
                    </div>
                    <div v-else>
                        Комната
                    </div>

                    <div class="room-info">
                        <div class="last-msg"></div>
                        <div style="float: right" class="lastMessageTime">
                            {{item.last_message_time | timestampTime}}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'Chats',
    data: () => ({
        searchBox: [],
        searchActive: false,
    }),
    props: {
        roomList: Array,
        currentRoom: Object,
    },
    computed: {
        ...mapGetters(['isMobile', 'current_room']),
        unreadMessageComputeStyle() {
            return (item) => {
                return (item.new_messages > 0) &&
                        (item.id != this.currentRoom.id);
            };
        },
    },
    methods: {
        closeSearch() {
            this.searchActive = false;
            this.searchBox = [];
            this.$refs.searchInput.value = '';
        },
        createRoom(){
            this.$emit('create-room');
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    @mixin custom-scroll-bar {
        &::-webkit-scrollbar {
            height: auto;
            width: 0.3rem;
        }

        &::-webkit-scrollbar-thumb {
            background: #E1E1E1;
            border-radius: 0.3rem;
        }

        &::-webkit-scrollbar-track {
            background: none;
        }
    }

    $chat-border-grid: rem(1) solid #F2F2F2;

    .chats-wrapper {
        width: 12rem;
        border-right: $chat-border-grid;
        display: flex;
        flex-direction: column;
    }

    .chats-header {
        padding: 1.4rem 1.4rem 0.7rem;
        color: #0465AC;
        font-size: 1.1rem;
        font-weight: 600;
        border-bottom: $chat-border-grid;
        position: relative;

        .roomCreator {
            height: 1.8rem;
            width: 100%;
            background: #F2F2F2;
            border-radius: 0.3rem;
            margin-top: 0.7rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size: 0.6rem;
            cursor: pointer;
            &:hover{
                border: rem(1) solid #0465AC;
            }

            /*.search-input {*/
            /*    width: 100%;*/
            /*    height: 100%;*/
            /*    border: none;*/
            /*    background: none;*/
            /*    padding: 0.5rem;*/
            /*    font-size: 0.6rem;*/
            /*}*/

            /*.icon {*/
            /*    font-size: 0.7rem;*/
            /*    margin-left: 0.5rem;*/
            /*    margin-right: 0.5rem;*/
            /*}*/
        }
    }

    .rooms {
        @include custom-scroll-bar;

        flex: 1;
        position: relative;
        overflow-y: scroll;

        .search-box {
            @include custom-scroll-bar;

            position: absolute;
            top: 0;
            left: 0;
            background: #F2F2F2;
            max-height: 100%;
            overflow-y: scroll;
            width: 90%;

            .search-item {
                position: relative;
                padding: 0.5rem;
                font-size: 0.6rem;
                border-bottom: rem(1) solid rgb(224, 224, 224);
                cursor: pointer;
                width: 100%;
            }
        }

        .room {
            padding: 0.7rem;
            font-size: 0.6rem;
            font-weight: 600;
            border-bottom: $chat-border-grid;
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            height: 5em;
            overflow: hidden;

            &.current-room {
                background: rgba(209, 232, 252, 0.5);
            }
            &.hasUnreadMessageBg {
                background: #f5f7fa;
            }

            .room-img {
                border-radius: 50%;
                height: 1.8rem;
                width: 1.8rem;
                overflow: hidden;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                .singroomImgItem{
                    width: 100%;
                    height: 100%;
                    background-size: cover;
                    background-position: center center;
                    background-repeat: no-repeat;
                }
                .roomImgItem{
                    background-size: cover;
                    background-position: center center;
                    background-repeat: no-repeat;
                    width: 50%;
                    height: 50%;
                    flex: 1;
                }
            }

            .room-name {
                margin-left: 0.7rem;
                flex: 1;

                .room-first {
                    margin-bottom: 5px;
                    height: 18px;
                }

                .room-info {
                    clear: both;

                    .last-msg {
                        float: left;
                        font-weight: 400;
                    }
                }

                .lastMessageTime{
                    font-size: 0.5rem;
                    color: grey;
                    margin-top: 0.2rem;
                }
            }

            .unreadMessages{
                margin-left: 1rem;
                background: #4663AB;
                border-radius: 50%;
                color: white;
                width: 1.2rem;
                height: 1.2rem;
                padding: 0.2rem;
                font-size: 0.5rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    @import "../../../styles/variables";
    @media (max-width: $vm) {
        .chats-wrapper {
            width: 100%;
            padding: mrem(10);
        }

        .chats-header {
            padding: 0;
            margin-bottom: mrem(10);

            .roomCreator {
                height: mrem(30);
                font-size: mrem(12);
            }
        }

        .rooms {
            @include custom-scroll-bar;

            flex: 1;
            position: relative;
            overflow-y: scroll;

            .search-box {
                @include custom-scroll-bar;

                position: absolute;
                top: 0;
                left: 0;
                background: #F2F2F2;
                max-height: 100%;
                overflow-y: scroll;
                width: 90%;

                .search-item {
                    position: relative;
                    padding: 0.5rem;
                    font-size: 0.6rem;
                    border-bottom: rem(1) solid rgb(224, 224, 224);
                    cursor: pointer;
                    width: 100%;
                }
            }

            .room {
                padding: 0.7rem;
                font-size: mrem(14);
                font-weight: 600;
                border-bottom: $chat-border-grid;
                display: flex;
                flex-direction: row;
                align-items: center;
                cursor: pointer;
                height: mrem(60);
                overflow: hidden;

                &.current-room {
                    background: rgba(209, 232, 252, 0.5);
                }
                &.hasUnreadMessageBg {
                    background: #f5f7fa;
                }

                .room-img {
                    border-radius: 50%;
                    height: mrem(40);
                    width: mrem(40);
                    overflow: hidden;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    .singroomImgItem{
                        width: 100%;
                        height: 100%;
                        background-size: cover;
                        background-position: center center;
                        background-repeat: no-repeat;
                    }
                    .roomImgItem{
                        background-size: cover;
                        background-position: center center;
                        background-repeat: no-repeat;
                        width: 50%;
                        height: 50%;
                        flex: 1;
                    }
                }

                .room-name {
                    margin-left: 0.7rem;
                    flex: 1;

                    .lastMessageTime{
                        font-size: mrem(12);
                        color: grey;
                        margin-top: 0.2rem;
                    }
                }

                .unreadMessages{
                    width: mrem(18);
                    height: mrem(18);
                    padding: 0.2rem;
                    font-size: mrem(10);
                }
            }
        }

        .search {
            .search-icon {
                position: absolute;
                top: mrem(8);
                left: mrem(14);
            }

            .search-input {
                width: 100%;
                height: mrem(40);
                border: none;
                background: #F7F7F8;
                border-radius: mrem(4);
                padding: mrem(10) mrem(10) mrem(10) mrem(50);
            }
        }
    }
</style>
